import {
    getAmenity,
    deleteAmenity,
    createAmenity,
    updateAmenity
} from '../../../services/AmenityService';
import {
    CONFIRMED_GET_AMENITY
} from './AmenityTypes';

export function getAmenityAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'AMENITY_LOADING' });
            getAmenity(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetAmenityAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetAmenityAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetAmenityAction(data) {
    return {
        type: CONFIRMED_GET_AMENITY,
        payload: data,
    };
}

export function deleteAmenityAction(id, history) {
    return (dispatch, getState) => {
        return deleteAmenity(id).then((response) => {
            return response;
        });
    };
}

export function createAmenityAction(data) {
    return () => {
        return createAmenity(data).then((response) => {
            return response;
        });
    };
}

export function updateAmenityAction(id, data) {
    return () => {
        return updateAmenity(id, data).then((response) => {
            return response;
        });
    };
}

